import { Checkbox } from "../Checkbox";

import type { StyleProp, ViewStyle } from "react-native";

export function DialogCheckbox({
  onChangeChecked,
  checked,
  label = "",
  style,
}: {
  onChangeChecked: (checked: boolean) => void;
  checked: boolean;
  label?: string;
  style?: StyleProp<ViewStyle>;
}) {
  return (
    <Checkbox
      name="dialogCheckbox"
      label={label}
      onChangeChecked={(isChecked) => {
        onChangeChecked(isChecked as boolean);
      }}
      checked={checked}
      style={style}
    />
  );
}
